<template>
    <div>
        <van-search placeholder="搜索姓名/地区" v-model="value" @input="onSearch" style="border-bottom: 10px #F3F3F3 solid;"/>
        <van-cell v-for="(item,index) in list" :key="index" @click="gotoDetail(item.id)">
            <template slot="title">
                <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 0;">
                    <van-image round :src="item.imageUrl" width="50px" height="50px"/>
                    <div style="flex: 5; margin-left:12px; display: flex; flex-direction: column; align-items: start;">
                        <div style="color: #333333; font: 14px normal;">{{item.userName}}</div>
                        <div style="color: #999999; font-size: 14px;">{{type === '1' ? `${item.city}大使` :
                            `益宝${item.city}枢纽伙伴`}}
                        </div>
                    </div>
                    <a :href="`tel:${item.userPhone}`" style="flex:1; font-size: 12px; color:#1C7CF8;">联系Ta</a>
                    <van-icon name="arrow"></van-icon>
                </div>
            </template>
        </van-cell>
    </div>

</template>

<script>

    import Vue from 'vue';
    import {Search, Cell, Image, Icon} from 'vant';
    import Cookies from 'js-cookie'

    Vue.use(Search).use(Cell).use(Image).use(Icon);

    export default {
        name: "AmbassadorList",
        data() {
            return {
                type: Cookies.get('type'),
                list: [],
                value: '',
            }
        },
        created() {
            this.loadListData()
        },
        methods: {
            onSearch() {
                this.loadListData()
            },
            loadListData() {
                this.$axios.get("/ambassador/ownLocal", {params: {name: this.value, type: this.type}}).then(res => {
                    this.list = res.data;
                }).catch(err => {
                    console.log(err);
                })
            },
            gotoDetail(id) {
                // this.$router.push({path: '/ambassadorDetail', query: {id: id}})
                window.location.href = `${process.env.VUE_APP_SHARE_URL}/ambassadorDetail?id=${id}`
            }

        }
    }
</script>

<style>

</style>
